module.exports = "/_next/static/images/img1@2x-c88a7da51b1ccf667bee39765960250a.png";